import { render, staticRenderFns } from "./ProcessInstanceList.vue?vue&type=template&id=19263c6c&scoped=true&"
import script from "./ProcessInstanceList.vue?vue&type=script&lang=js&"
export * from "./ProcessInstanceList.vue?vue&type=script&lang=js&"
import style0 from "./ProcessInstanceList.vue?vue&type=style&index=0&id=19263c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19263c6c",
  null
  
)

export default component.exports